import React, { FC, RefObject } from 'react'
import { Direction, REQUEST_CONFIGS_KEYS } from '@services/constants'
import TextInput from '../inputs/text.inputs'
import RadioInput from '../inputs/radio.input'
import { CheckboxList, RadioList } from '@utils/request'
import * as utilsList from './__index.utils'
import Notification from '@components/ui/notification'
import CheckboxInput from '../inputs/checkbox.input'
import MeasurementInput from '../inputs/measurement.input'
import {
	isArtisticWallRepresentationInstallation,
	isNewSignInstallation,
	isReplaceSignInstallation
} from './__index.utils'
import MaskedThousandsSeparatorInput from '../inputs/textWithThousandsSeparator.inputs'

const Step4_4InstallationOfEnseigne = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	updateCheckBoxInput
}) => {
	const {
		whatToDo,

		// ***********************
		typesOfWorkOccupation,

		typesOfWorkEnseigne,
		newEnseignesNumber,
		replacedEnseignesNumber,
		muralRepresentationsNumber,
		totalSignArea,
		totalSignAreaUnit,
		approximateCostOfWorkEnseigne,
		areModificationsToPremisesNecessary,
		isChangeOfUsePlanned
	} = formInputs

	const radioListTypesOfWorkEnseigne: CheckboxList[] =
		utilsList.radioListTypesOfWorkEnseigne(pageAssets)

	const radioListMeasurement2Unit: RadioList[] =
		utilsList.radioListMeasurement2Unit(pageAssets)

	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)

	const displayNewEnseignesNumber = () => {
		return (
			<TextInput
				id={newEnseignesNumber.name}
				label={newEnseignesNumber.label}
				value={newEnseignesNumber.value}
				onChange={(value) => updateInput(newEnseignesNumber.name, value)}
				hasError={errors!.includes(newEnseignesNumber.name)}
				required={newEnseignesNumber.required}
				ref={newEnseignesNumber.ref as RefObject<HTMLInputElement>}
				maxCharacters={3}
				type="text"
				onKeyPress={pageUtils.onKeyPressIntegerInput}
				min="0"
				isSummaryStep={isSummaryStep}
			/>
		)
	}

	const displayReplacedEnseignesNumber = () => {
		return (
			<TextInput
				id={replacedEnseignesNumber.name}
				label={replacedEnseignesNumber.label}
				value={replacedEnseignesNumber.value}
				onChange={(value) => updateInput(replacedEnseignesNumber.name, value)}
				hasError={errors!.includes(replacedEnseignesNumber.name)}
				required={replacedEnseignesNumber.required}
				ref={replacedEnseignesNumber.ref as RefObject<HTMLInputElement>}
				maxCharacters={3}
				type="text"
				onKeyPress={pageUtils.onKeyPressIntegerInput}
				min="0"
				isSummaryStep={isSummaryStep}
			/>
		)
	}

	const displayArtificialWall = () => {
		return (
			<TextInput
				id={muralRepresentationsNumber.name}
				label={muralRepresentationsNumber.label}
				value={muralRepresentationsNumber.value}
				onChange={(value) =>
					updateInput(muralRepresentationsNumber.name, value)
				}
				hasError={errors!.includes(muralRepresentationsNumber.name)}
				required={muralRepresentationsNumber.required}
				ref={muralRepresentationsNumber.ref as RefObject<HTMLInputElement>}
				maxCharacters={3}
				type="text"
				onKeyPress={pageUtils.onKeyPressIntegerInput}
				min="0"
				isSummaryStep={isSummaryStep}
			/>
		)
	}

	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_enseigne_informations}
				</h4>
			)}

			<CheckboxInput
				name={typesOfWorkEnseigne.name}
				label={typesOfWorkEnseigne.label}
				description={typesOfWorkEnseigne.description}
				value={`${typesOfWorkEnseigne.value}`}
				list={radioListTypesOfWorkEnseigne}
				onChange={(value) => updateCheckBoxInput(typesOfWorkEnseigne, value)}
				required={typesOfWorkEnseigne.required}
				hasError={errors.includes(typesOfWorkEnseigne.name)}
				ref={typesOfWorkEnseigne.ref as RefObject<HTMLInputElement>}
				errors={errors}
				shouldNotDivide
				hasBackgroundWrapper
				onFixError={onFixError}
				newCheckValue
				subTextInputs={[
					displayNewEnseignesNumber(),
					displayReplacedEnseignesNumber(),
					displayArtificialWall()
				]}
				isSummaryStep={isSummaryStep}
			/>

			<MeasurementInput
				measurementInput={totalSignArea}
				unitInput={totalSignAreaUnit}
				listMeasurementUnit={radioListMeasurement2Unit}
				maxCharacters={12}
				isSummaryStep={isSummaryStep}
				errors={errors}
				onFixError={onFixError}
				updateInput={updateInput}
				hasError={errors?.includes(totalSignArea.name)}
				reducedMargin
				disableWarningTooltip
			/>

			<MaskedThousandsSeparatorInput
				id={approximateCostOfWorkEnseigne.name}
				label={approximateCostOfWorkEnseigne.label}
				value={approximateCostOfWorkEnseigne.value}
				description={approximateCostOfWorkEnseigne.description}
				onChange={(value: string) => {
					updateInput(approximateCostOfWorkEnseigne.name, value?.toString())
				}}
				hasError={errors.includes(approximateCostOfWorkEnseigne.name)}
				required={approximateCostOfWorkEnseigne.required}
				ref={approximateCostOfWorkEnseigne.ref as RefObject<HTMLInputElement>}
				errors={errors}
				setError={onFixError}
				displayCurrency
				maxCharacters={12}
				isSummaryStep={isSummaryStep}
				// scaleToZero={true}
			/>

			{(!isSummaryStep ||
				(isSummaryStep &&
					(areModificationsToPremisesNecessary.value != '' ||
						isChangeOfUsePlanned.value != ''))) && (
				<h5 className={pageUtils.classes.h5}>
					{pageAssets?.request_form_additional_info}
				</h5>
			)}

			<RadioInput
				name={areModificationsToPremisesNecessary.name}
				label={areModificationsToPremisesNecessary.label}
				value={areModificationsToPremisesNecessary.value}
				list={radioListYesNo}
				direction={Direction.vertical}
				hasError={errors!.includes(areModificationsToPremisesNecessary.name)}
				onChange={(value) =>
					updateInput(areModificationsToPremisesNecessary.name, value)
				}
				ref={
					areModificationsToPremisesNecessary.ref as RefObject<HTMLInputElement>
				}
				required={areModificationsToPremisesNecessary.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
				reducedMargin={true}
			/>

			{!isSummaryStep &&
				areModificationsToPremisesNecessary.value?.toString() == 'true' && (
					<Notification
						text={
							pageAssets?.request_form_areModificationsToPremisesNecessary_notification
						}
						type="info"
						hasHtml
					/>
				)}

			<RadioInput
				name={isChangeOfUsePlanned.name}
				label={isChangeOfUsePlanned.label}
				value={isChangeOfUsePlanned.value}
				list={radioListYesNo}
				direction={Direction.vertical}
				hasError={errors!.includes(isChangeOfUsePlanned.name)}
				onChange={(value) => updateInput(isChangeOfUsePlanned.name, value)}
				ref={isChangeOfUsePlanned.ref as RefObject<HTMLInputElement>}
				required={isChangeOfUsePlanned.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
				reducedMargin={true}
			/>

			{!isSummaryStep && isChangeOfUsePlanned.value?.toString() == 'true' && (
				<Notification
					text={pageAssets?.request_form_isChangeOfUsePlanned_notification}
					type="info"
					hasHtml
				/>
			)}
		</>
	)
}

export default Step4_4InstallationOfEnseigne
